import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CA } from 'src/app/shared/entities/ca';
import { FormFieldComponent } from 'src/app/shared/form-field/components/form-field/form-field.component';
import { FormFieldsDirective } from 'src/app/shared/form-field/directives/form-fields/form-fields.directive';
import { FormFieldOptions } from 'src/app/shared/form-field/form-field.types';
import { FormFieldService } from 'src/app/shared/form-field/services/form-field/form-field.service';
import { LangService } from 'src/app/shared/services/lang/lang.service';

@Component({
  selector: 'app-revoke-ica-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormFieldComponent,
    FormFieldsDirective,
  ],
  providers: [FormFieldService],
  templateUrl: './revoke-ica-dialog.html',
  styleUrl: './revoke-ica-dialog.scss',
})
export class RevokeIcaDialogComponent {
  private fb = inject(FormBuilder);
  private langService = inject(LangService);
  private formFieldService = inject(FormFieldService);
  private config: { ca: CA } = inject(MAT_DIALOG_DATA);
  ca = this.config.ca;

  form = this.fb.group({
    reason: ['', [Validators.required]],
    revokeLeafCertificates: [false],
  });

  labels = this.langService.lang.features.calist.revokeDialog;

  subtitle = this.labels.subtitle(this.config.ca.caName ?? '');

  constructor() {
    this.formFieldService.configure({
      labels: this.labels.inputs,
      options: {
        reason: FormFieldOptions.select({
          required: true,
        }),
        revokeLeafCertificates: FormFieldOptions.checkbox(),
      },
    });
  }
}
